import { useInstitutionsContext } from 'contexts/institutions'
import {
    getFromSessionStorage,
    removeFromSessionStorage,
    saveToSessionStorage
} from 'utils/sessionStorage'

interface DataToPersistFilters {
    to: string
    from: string
    page: number
    limit: number
    filter: any
}

export const useCacheFilters = () => {
    const keyCache = 'cache-filters'

    const { institutions, currentInstitution, currentAgent, agents } =
        useInstitutionsContext()

    const persistCacheFilters = ({
        page,
        to,
        from,
        limit,
        filter
    }: DataToPersistFilters) => {
        const dataCache = {
            currentAgent,
            currentInstitution,
            institutions,
            agents,
            to,
            from,
            page,
            limit,
            filter
        }

        saveToSessionStorage(keyCache, dataCache)
    }

    const getCacheFilters = () => {
        const cacheFilters = getFromSessionStorage(keyCache)

        if (!cacheFilters) return null

        const { currentInstitution, institutions } = cacheFilters

        return {
            currentInstitution,
            institutions,
            currentAgent: cacheFilters.currentAgent,
            agents: cacheFilters.agents.length ? cacheFilters.agents : [],
            to: cacheFilters.to,
            from: cacheFilters.from,
            page: cacheFilters.page,
            limit: cacheFilters.limit,
            filter: cacheFilters.filter
        }
    }

    const resetCacheFilters = () => {
        removeFromSessionStorage(keyCache)
    }

    const cleanCacheFilters = () => {
        const cacheFilters = getFromSessionStorage(keyCache)
        if (!cacheFilters) return

        const currentURL = window.location.href
        if (
            currentURL.includes(cacheFilters.from) ||
            currentURL.includes(cacheFilters.to)
        )
            return

        resetCacheFilters()
    }

    const hasCacheFilters = !!getCacheFilters()

    return {
        persistCacheFilters,
        cleanCacheFilters,
        getCacheFilters,
        resetCacheFilters,
        hasCacheFilters
    }
}
